import { BaseModel } from "../../Bases/BaseModel";

export class UsuarioOperacao extends BaseModel {
  constructor(
    public usuario_id = 0,
    public operacao_id = 0,
    public operacao_nome = '',
    public operacao_permissao_grupo_id = 0,
    public operacao_permissao_grupo_nome = '',
    public visivel_cone = true,
    public hide = false
  ) {
    super();
  }
}
